import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=594486ea&scoped=true"
import script from "./NewHeader.vue?vue&type=script&lang=js"
export * from "./NewHeader.vue?vue&type=script&lang=js"
import style0 from "./NewHeader.vue?vue&type=style&index=0&id=594486ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594486ea",
  null
  
)

export default component.exports